import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { AdminDailyStatsState } from "../../models/mp-admin/admin-daily-stats-state";

const initialState: AdminDailyStatsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.dailyStats.getApi, (state, action) =>
		_.set(_.cloneDeep(state), "loading", true)
	),
	on(MpAdminActions.dailyStats.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpAdminActions.dailyStats.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function adminDailyStatsReducer(
	state: AdminDailyStatsState,
	action: Action
): AdminDailyStatsState {
	return reducer(state, action);
}
